import { TextInput } from '@core/components/Inputs';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import { SelectCategoria, SelectCliente, SelectServico } from 'app/components/Select';
import { useFormikContext } from 'formik';
import React from 'react';

const onlyNumberRegex = /^\d*$/;

const ContratoBuscaAvancadaForm = () => {
  const formikContext = useFormikContext();
  const { values, handleChange, handleBlur } = formikContext;

  return (
    <Grid container style={{ padding: 16 }} spacing={3}>
      <Grid item xs={6}>
        <TextInput
          id="identificador"
          name="identificador"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.identificador}
          maxLength={3}
          fullWidth
          variant="outlined"
          label="Identificador"
          pattern={onlyNumberRegex}
        />
      </Grid>
      <Grid item xs={6}>
        <FormControl variant="outlined" style={{ width: '100%' }}>
          <InputLabel id="situacao">Situação</InputLabel>
          <Select
            id="situacao"
            name="situacao"
            label="Situação"
            labelId="situacao"
            value={values?.situacao}
            onChange={handleChange}
            onBlur={handleBlur}
          >
            <MenuItem value="ATIVO">Ativo</MenuItem>
            <MenuItem value="ENCERRADO">Encerrado</MenuItem>
            <MenuItem value="RESCINDIDO">Rescindido</MenuItem>
            <MenuItem value="TODAS">Todas</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <SelectCliente
          id="cliente"
          name="cliente"
          label="Cliente"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.cliente}
        />
      </Grid>
      <Grid item xs={12}>
        <SelectServico
          id="servico"
          name="servico"
          label="Servico"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.servico}
        />
      </Grid>
      <Grid item xs={12}>
        <SelectCategoria
          id="categoria"
          label="Categoria"
          value={values?.categoria}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={100}
          natureza="RECEITA"
        />
      </Grid>
    </Grid>
  );
};

export default ContratoBuscaAvancadaForm;
